import React from 'react';
import * as styles from '../../TestimonialTile.module.scss';
const TestimonialQuote = ({
  quote
}) => /*#__PURE__*/React.createElement(React.Fragment, null, quote && /*#__PURE__*/React.createElement("blockquote", {
  className: styles.rootQuote
}, quote));
export default TestimonialQuote;